@if (shouldShowActions) {
    <div class="d-flex justify-content-center mt-4">
        <div>
            <button class="btn btn-dark mx-2" (click)="onBackButtonClick()" type="button">
                {{ backButtonLabel }}
            </button>
        </div>

        @if (shouldShowRequestButton) {
            <app-reactive-request-button
                [form]="form"
                [model]="model"
                [recordHasAssociatedData]="recordHasAssociatedData"
                [request]="request"
                [getRequest]="getRequest"
                [lockOnSuccess]="true"
                [resolveDropdownRawValue]="resolveDropdownRawValue"
                [resolveDropdownBackendValue]="resolveDropdownBackendValue"
                (goBack)="goBack.emit()"
                (afterSend)="afterSend.emit($event)">
            </app-reactive-request-button>
        }
    </div>
}
